import clsx from "clsx";

function Icon({
    children,
    viewBox = "0 0 20 20",
    className,
    fill = "currentColor",
    stroke,
    ...props
}) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox={viewBox}
            {...props}
            fill={fill}
            stroke={stroke}
            className={clsx(
                className,
            )}
        >
            {children}
        </svg>
    );
}


export function IconReport({ ...props }) {
    return (
        <Icon
            {...props}
            className={`${props.className}`}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M6.85721 14.5713H1.71436V20.5713H6.85721V14.5713Z" fill={props.color} />
            <path d="M15.4286 7.71387H9.42862V20.571H15.4286V7.71387Z" fill={props.color} />
            <path d="M23.1429 1.71387H18.0001V20.571H23.1429V1.71387Z" fill={props.color} />
            <path d="M0 0V23.347C0 23.5189 0.0710635 23.6872 0.195079 23.8084C0.319555 23.9301 0.49096 24 0.666968 24H24V22.6935H1.3339V0H0Z" fill={props.color} />
        </Icon>
    );
}

export function IconHint({ ...props }) {
    return (
        <Icon
            {...props}
            className={`${props.className}`}
            viewBox="0 0 43 41"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g filter="url(#filter0_d_6254_77838)">
                <path d="M23.3522 10.9113C22.8687 8.31295 25.971 5.55089 28.445 10.2897C29.2254 11.7845 27.0519 8.04818 29.7912 7.26535C31.1609 6.87394 32.4021 7.55753 33.823 10.2897C36.0566 14.5844 36.3355 18.144 35.2175 20.4429C37.2984 22.2695 37.8092 24.7717 35.8583 26.0677C33.9074 27.3638 27.7948 31.5562 23.763 31.8171C20.1214 32.0528 19.4711 28.4162 19.4711 28.4162C16.2679 28.5832 14.5432 26.9615 11.7736 22.293C1.91333 22.293 4.64455 14.9864 9.19655 14.9864H11.7736C10.2033 11.9491 8.49786 7.65165 9.19655 4.28766C9.84685 1.15665 15.8751 1.00274 16.0896 3.89625C16.2813 6.48292 17.2807 9.96627 17.8681 11.8382C17.1844 8.11828 21.4485 6.13527 23.3522 10.9113Z" fill="white" />
                <path d="M33.2572 22.5537C36.2485 20.8576 36.9444 16.2915 33.823 10.2897C32.4021 7.55753 31.1609 6.87394 29.7912 7.26535C27.0519 8.04818 29.2254 11.7845 28.445 10.2897C25.7081 5.04734 22.2023 8.98466 23.6329 11.7249C21.7277 5.30828 16.0896 8.43959 18.3006 13.1597C18.3006 13.1597 16.3646 7.60586 16.0896 3.89625C15.8751 1.00274 9.84685 1.15665 9.19655 4.28766C8.49786 7.65165 10.2033 11.9491 11.7736 14.9864M14.0087 18.77C14.0087 18.77 12.9277 17.2185 11.7736 14.9864M11.7736 14.9864H9.19655C4.64455 14.9864 1.91333 22.293 11.7736 22.293C14.5432 26.9615 16.2679 28.5832 19.4711 28.4162M21.9422 28.0335C20.8059 28.2944 20.2066 28.3779 19.4711 28.4162M19.4711 28.4162C19.4711 28.4162 20.1214 32.0528 23.763 31.8171C27.7948 31.5562 33.9074 27.3638 35.8583 26.0677C37.8092 24.7717 37.2984 22.2695 35.2175 20.4429M23.893 27.2978C25.3693 26.5751 26.1496 26.1837 27.9248 25.198" stroke="#808080" stroke-width="2.03215" stroke-linecap="round" stroke-linejoin="round" />
            </g>
            <defs>
                <filter id="filter0_d_6254_77838" x="-2.28882e-05" y="-0.000358582" width="42.1605" height="40.1608" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="3.25143" />
                    <feGaussianBlur stdDeviation="2.03215" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6254_77838" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6254_77838" result="shape" />
                </filter>
            </defs>
        </Icon>
    );
}

